module.exports = __webpack_public_path__ + "static/media/recharging-your-battery@2x.e9426915.png";